import { gql } from "@apollo/client"

export const STORE_EDIT = gql`
  mutation StoreEdit($input: StoreEditInput!) {
    StoreEdit(input: $input) {
      status {
        success
        name
        detail
      }
      store {
        id
        name
        description
        phone
        email
        urlLogo
        cover
        siteUrl
        facebookUrl
        instagramUrl
        youtubeUrl
        twitterUrl
        Address {
          id
          name
          address
          countryId
          regionId
          locationId
          Country {
            name
          }
          Region {
            fullName
          }
          Location {
            name
          }
        }
      }
    }
  }
`
